import React from "react";

const LiveInspection = ({
  width = 46,
  height = 46,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="44" height="44" rx="22" fill="white" />
      <rect x="1" y="1" width="44" height="44" rx="22" stroke="#E2E4E9" />
      <path
        d="M23.0008 24.8016V26.6016C21.5686 26.6016 20.1951 27.1705 19.1824 28.1832C18.1697 29.1959 17.6008 30.5694 17.6008 32.0016H15.8008C15.8008 30.092 16.5594 28.2607 17.9096 26.9104C19.2599 25.5601 21.0912 24.8016 23.0008 24.8016ZM23.0008 23.9016C20.0173 23.9016 17.6008 21.4851 17.6008 18.5016C17.6008 15.5181 20.0173 13.1016 23.0008 13.1016C25.9843 13.1016 28.4008 15.5181 28.4008 18.5016C28.4008 21.4851 25.9843 23.9016 23.0008 23.9016ZM23.0008 22.1016C24.9898 22.1016 26.6008 20.4906 26.6008 18.5016C26.6008 16.5126 24.9898 14.9016 23.0008 14.9016C21.0118 14.9016 19.4008 16.5126 19.4008 18.5016C19.4008 20.4906 21.0118 22.1016 23.0008 22.1016ZM30.946 31.1655L28.4008 33.8016L25.8556 31.1655C24.4489 29.7093 24.4489 27.3495 25.8556 25.8933C26.1838 25.5484 26.5786 25.2739 27.0161 25.0863C27.4537 24.8987 27.9247 24.8019 28.4008 24.8019C28.8768 24.8019 29.3479 24.8987 29.7854 25.0863C30.223 25.2739 30.6178 25.5484 30.946 25.8933C32.3527 27.3495 32.3527 29.7093 30.946 31.1655ZM29.6518 29.9145C30.3835 29.1567 30.3835 27.9021 29.6518 27.1443C29.4915 26.973 29.2978 26.8365 29.0826 26.7432C28.8674 26.6499 28.6353 26.6017 28.4008 26.6017C28.1662 26.6017 27.9342 26.6499 27.719 26.7432C27.5038 26.8365 27.3101 26.973 27.1498 27.1443C26.4181 27.9021 26.4181 29.1567 27.1498 29.9154L28.4008 31.2096L29.6518 29.9136V29.9145Z"
        fill="#525866"
      />
    </svg>
  );
};

export default LiveInspection;
